import { Injectable } from '@angular/core';
import { SvMessageService } from './sv-message.service';
import { SvMessageType } from '../components/sv-message/sv-message.component';

/**
 * NotificationService
 *
 * Service focado em notificações e mensagens ao utilizador:
 * - Popup messages (sv-message nativo)
 * - Geolocation/Maps
 */
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private svMessage: SvMessageService) {}

  /**
   * Mostra uma mensagem popup via sv-message nativo
   * @param message Mensagem a mostrar
   * @param action Texto do botão de ação (ignorado, mantido para compatibilidade)
   * @param tipo Tipo: 'success', 'error', 'info', 'warning'
   */
  PopupMessage(message: string, _action: string, tipo: string) {
    const type: SvMessageType = (tipo as SvMessageType) || 'info';

    // Para success e info usar modal nativo (com auto-fechar no caso de success)
    if (type === 'success') {
      return this.svMessage.success(message, undefined, 3000);
    }
    if (type === 'info') {
      return this.svMessage.info(message);
    }

    // Para error e warning usar modal (requer ação do utilizador)
    return this.svMessage.fire({
      type,
      title: type === 'error' ? 'Erro' : 'Aviso',
      text: message,
      confirmButtonText: 'OK',
    });
  }

  /**
   * Abre Google Maps com coordenadas específicas
   */
  openGoogleMapsWithLocation(latitude: number, longitude: number) {
    const url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    window.open(url, '_blank');
  }

  /**
   * Obtém localização atual do utilizador e abre no Google Maps
   */
  getLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          this.openGoogleMapsWithLocation(latitude, longitude);
          console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
        },
        error => {
          console.error('Erro ao obter a localização:', error);
        },
      );
    } else {
      console.error('Geolocalização não suportada neste navegador.');
    }
  }
}
